import { Typography, styled } from '@mui/material';

export const TitleName = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
`;

export const TitleCategory = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-transform: capitalize;
`;

export const DotsButton = styled('button')`
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;

export const MenuItemContent = styled('span')`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 400;
`;
